import { OptionType, Progress, SelectWithApiClient } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { ProductData, User } from 'modules/domain/user/types'
import { refetchFunc } from 'modules/domain/common/hooks'
import InlineProgress from './InlineProgress'

type Props = {
  data: ProductData
  refetch: refetchFunc
  user: User
  disabled: boolean
}
const ProductDropDown: FC<Props> = ({ data, user, refetch, disabled }) => {
  const [progress, execute, error] = useAProgress(
    async (opt: OptionType) => {
      if (!user.profile?.company) {
        return
      }
      if (data.id) {
        await apiClient.patch(endpoints.companyProductData(user.profile.company.id, data.id.toString()), {
          product: opt.value,
        })
      } else {
        await apiClient.post(endpoints.companyProductData(user.profile.company.id), {
          product: opt.value,
          user: user.id,
        })
      }
      await refetch(true)
    },
    {
      eventName: 'price',
      scope: 'change',
    },
  )

  return (
    <div style={{ position: 'relative' }}>
      <InlineProgress enabled={progress === Progress.WORK} />
      <SelectWithApiClient
        error={!!error}
        apiClient={apiClient}
        endpoint={endpoints.products()}
        simpleApiFormat
        showSearch={false}
        allowClear={false}
        getLabel={(dto) => dto.title}
        onChange={execute}
        value={data.product ? data.product.id.toString() : undefined}
        size="small"
        disabled={disabled}
      />
    </div>
  )
}

export default ProductDropDown
